import React, { Component } from 'react';
import { Select } from 'antd';

export enum States {
    all = -1,
    terminated = 0,
    requirement_started = 1,
    requirement_confirmed = 2,
    planning = 11,
    plan_submitted = 12,
    plan_communicated = 13,
    plan_adjust = 14,
    plan_denied = 10,
    plan_passed = 21,
    in_process = 31,
    delivery = 51,
    delivered = 52,
    invoiced = 60,
    payment_received = 100,
}

interface StatesSelectProps {
    onChange?: (value: number | number[] | null) => void; // 修改为接收单个数字或数组
    showAllOption?: boolean;
    initialValues?: number | number[]; 
    mode?: 'multiple' | undefined; // 添加模式选择属性
}

export const getRequirementStates = (states: States) => {
    switch (states) {
        case States.terminated:
            return '需求终止';
        case States.requirement_started:
            return '获得需求';
        case States.requirement_confirmed:
            return '需求已确认';
        case States.planning:
            return '方案制定中';
        case States.plan_submitted:
            return '已提供方案';
        case States.plan_communicated:
            return '已沟通方案';  
        case States.plan_adjust:
            return '方案需调整';      
        case States.plan_denied:
            return '方案否决';
        case States.plan_passed:
            return '方案通过';
        case States.in_process:
            return '商务流程';
        case States.delivery:
            return '交付中';
        case States.delivered:
            return '交付完成';
        case States.invoiced:
            return '已开票';  
        case States.payment_received:
            return '已收款';       
        default:
            return '其他';
    }
}

class RequeirementStatesSelect extends Component<StatesSelectProps> {
    state = {
        selectedValues: this.props.initialValues ?? []
    };

    componentDidUpdate(prevProps: StatesSelectProps) {
        if (prevProps.initialValues !== this.props.initialValues) {
            this.setState({ selectedValues: this.props.initialValues ?? [] });
        }
    }

    showAllOption = this.props.showAllOption !== undefined ? this.props.showAllOption : true;
    options = [
        { value: States.terminated, label: '需求终止' },
        { value: States.requirement_started, label: '获得需求' },
        { value: States.requirement_confirmed, label: '需求已确认' },
        { value: States.planning, label: '方案制定中' },
        { value: States.plan_submitted, label: '已提供方案' },
        { value: States.plan_communicated, label: '已沟通方案' },
        { value: States.plan_adjust, label: '方案需调整' },
        { value: States.plan_denied, label: '方案否决' },
        { value: States.plan_passed, label: '方案通过' },
        { value: States.in_process, label: '商务流程' },
        { value: States.delivery, label: '交付中' },
        { value: States.delivered, label: '交付完成' },
        { value: States.invoiced, label: '已开票' },
        { value: States.payment_received, label: '已收款' }
    ];
    filteredOptions = this.showAllOption ? [{ value: -1, label: '全部' }, ...this.options] : this.options;

    handleStatesSelectChange = (value: number | number[] | null | undefined) => {
        let newValues: number | number[] | null = [];

        if (this.props.mode === 'multiple') {
            if (Array.isArray(value)) {
                if (value.includes(-1)) {
                    if (value[value.length - 1] === -1) {
                        // 如果最后选择的是"全部"，则只保留"全部"
                        newValues = null;
                    } else {
                        // 如果选择了其他选项，则移除"全部"选项
                        newValues = value.filter(v => v !== -1);
                    }
                } else {
                    newValues = value;
                }
            }
        } else {
            if (typeof value === 'number') {
                newValues = value;
            } else if (value === undefined || value === null) {
                newValues = null;
            } else if (!Array.isArray(value)) {
                const parsedValue = Number(value);
                newValues = Number.isNaN(parsedValue) ? null : parsedValue;
            }
        }
    
        this.setState({ selectedValues: newValues });
        this.props.onChange?.(newValues);
    };

    render() {
        const selectValue = this.state.selectedValues === null
            ? (this.props.mode === 'multiple' ? [-1] : undefined)
            : this.state.selectedValues;

        return (
            <Select 
                className="select-requirement_states"
                mode={this.props.mode}
                onChange={this.handleStatesSelectChange}
                placeholder="请选择状态"
                value={selectValue}
                allowClear
            >
                {this.filteredOptions.map(option => (
                    <Select.Option key={option.value} value={option.value}>
                        {option.label}
                    </Select.Option>
                ))}
            </Select>
        );  
    }
};

export default RequeirementStatesSelect;
